export enum SubscribeSource {
  FOOTER = 'FOOTER',
  MODAL = 'MODAL',
  ORDER_RECAP_PAGE = 'ORDER_RECAP_PAGE',
  FIRST_ORDER_PAGE = 'FIRST_ORDER_PAGE',
  SIGNUP = 'SIGNUP',
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
}

export interface ChannelSubscription {
  subscribed: boolean;
}

export interface EmailChannelSubscription extends ChannelSubscription {}

export interface SmsChannelSubscription extends ChannelSubscription {
  phone?: string;
}

export interface ChannelsSubscriptions {
  email?: EmailChannelSubscription;
  sms?: SmsChannelSubscription;
  source: SubscribeSource;
}

export type Channel = keyof Omit<ChannelsSubscriptions, 'source'>;
